import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CommonModule, DatePipe } from '@angular/common';
import { ProductionHomeComponent } from './production-home/production-home.component';
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS
} from '@angular/common/http';
import { Interceptor } from '../../Services/Interceptor';
import { TranslationService } from '../../translation.service';
import { DynamicTranslationService } from '../../dynamic-translation.service';
import { TranslationCommunicationServiceService } from '../../translation-communication-service.service';
import { QzTrayService } from '../../qz-tray.service';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpLoaderFactory } from '../../app.module';
import { DepartmentsComponent } from './departments/departments.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { CategoriesComponent } from './categories/categories.component';
import { ProductionComponent } from './production/production.component';
import { TopPerformerComponent } from './top-performer/top-performer.component';
import { ProdHistoryComponent } from './prod-history/prod-history.component';
import { Daterangepicker } from 'ng2-daterangepicker';
import { MoveToFloorComponent } from './move-to-floor/move-to-floor.component';
import { NewEntryComponent } from './new-entry/new-entry.component';
import { NgxBarcodeModule } from 'ngx-barcode';
import { AuthenticationGuard } from '../../authentication.guard';

import { DashboardComponent } from './production-dashboard/dashboard/dashboard.component';
import { SubCategoryProductionComponent } from './sub-category-production/sub-category-production.component';
import { ScanPullsComponent } from './scan-pulls/scan-pulls.component';
import { NgxPermissionsModule } from 'ngx-permissions';
import { ProductionChatbotModuleModule } from '../production-chatbot-module/production-chatbot-module.module';
import { ChatbotComponent } from '../production-chatbot-module/chatbot/chatbot.component';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';
import { ProductionOverrideComponent } from './production-override/production-override.component';
import { PaginationComponent } from './pagination/pagination.component';
import { ProdTopPerformerV3Component } from './reports-v3/top-performerv3/top-performerv3.component';
import { ProdOverviewDashboardV3Component } from './reports-v3/production-overview-dashboard-v3/production-overview-dashboard-v3.component';

@NgModule({
  declarations: [
    ProductionHomeComponent,
    NavMenuComponent,
    DepartmentsComponent,
    CategoriesComponent,
    ProductionComponent,
    DashboardComponent,
    TopPerformerComponent,
    ProdHistoryComponent,
    MoveToFloorComponent,
    NewEntryComponent,
    SubCategoryProductionComponent,
    ScanPullsComponent,
    ProductionOverrideComponent,
    ProdTopPerformerV3Component,
    ProdOverviewDashboardV3Component
  ],

  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    Daterangepicker,
    MatTooltipModule,
    NgxBarcodeModule,
    NgxPermissionsModule.forChild(),
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    ProductionChatbotModuleModule,
    PaginationComponent,
    RouterModule.forChild([
      {
        path: 'home',
        component: ProductionHomeComponent,
        children: [
          {
            path: 'departments',
            component: DepartmentsComponent,
            canActivate: [AuthenticationGuard],
            data: { permission: 'General' }
          },
          {
            path: 'prod-item',
            component: ProductionComponent,
            canActivate: [AuthenticationGuard],
            data: { permission: 'General' }
          },
          {
            path: 'production-overview',
            component: DashboardComponent,
            canActivate: [AuthenticationGuard],
            data: { permission: 'Report:ViewPSProductionOverview' }
          },

          {
            path: 'performer',
            component: TopPerformerComponent,
            canActivate: [AuthenticationGuard],
            data: { permission: 'Report:ViewPSTopPerformer' }
          },
          {
            path: 'v3',
            children: [
              {
                path: 'production-overview',
                component: ProdOverviewDashboardV3Component,
                canActivate: [AuthenticationGuard],
                data: { permission: 'Report:ViewPSProductionOverview' }
              },
              {
                path: 'performer',
                component: ProdTopPerformerV3Component,
                canActivate: [AuthenticationGuard],
                data: { permission: 'Report:ViewPSTopPerformer' }
              }
            ]
          },
          {
            path: 'move-floor',
            component: MoveToFloorComponent,
            canActivate: [AuthenticationGuard],
            data: { permission: 'Item:MoveToFloor' }
          },
          {
            path: 'history',
            component: ProdHistoryComponent,
            canActivate: [AuthenticationGuard],
            data: { permission: 'History:View' }
          },
          {
            path: 'new-entry',
            component: NewEntryComponent,
            canActivate: [AuthenticationGuard],
            data: { permission: 'Item:BulkEntry' }
          },
          {
            path: 'scan-pulls',
            component: ScanPullsComponent,
            canActivate: [AuthenticationGuard],
            data: { permission: 'Item:ScanPull' }
          },
          {
            path: 'sub-categories',
            component: SubCategoryProductionComponent,
            canActivate: [AuthenticationGuard],
            data: { permission: 'General' }
          },
          {
            path: 'chatbot',
            component: ChatbotComponent,
            canActivate: [AuthenticationGuard],
            data: { permission: 'General' }
          },
          {
            path: ':sub-dept',
            component: CategoriesComponent,
            canActivate: [AuthenticationGuard],
            data: { permission: 'General' }
          }
        ]
      }
    ])
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true },
    DatePipe,
    TranslationService,
    DynamicTranslationService,
    TranslationCommunicationServiceService,
    QzTrayService
  ]
})
export class ProductionModule {}
